/*
  edu-faq.js — the accordion's ARIA state, and nothing else.

  The accordion itself is a native <details>/<summary> disclosure and needs no
  JavaScript: it opens, closes, takes focus and responds to Enter and Space with
  scripting switched off entirely, and no answer is ever hidden in a way that a
  script has to undo. That property is the reason it was built this way and it
  is not given up here.

  What this file adds is the one thing the markup cannot state truthfully on its
  own: `aria-expanded`. Writing it into the Liquid would produce a second copy
  of a state the browser owns — right at page load and wrong from the first
  click, and a stale aria-expanded OVERRIDES the accurate native state, which
  makes the control less correct to a screen reader rather than more.

  So it is set from script and kept in sync by the `toggle` event, which the
  browser fires for every open and close however it was caused: pointer,
  keyboard, find-in-page, or another script. If this file fails to load, the
  attribute is simply absent and the native disclosure state is what assistive
  technology reads — the same thing it read before, and still correct.

  Deferred, idempotent, and safe to run again after a section re-render in the
  theme editor.
*/
(function () {
  'use strict';

  function sync(details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function bind(root) {
    var items = (root || document).querySelectorAll('details.rns-edu-faq__item');
    for (var i = 0; i < items.length; i++) {
      var details = items[i];
      if (details.dataset.rnsFaqBound === 'true') continue;
      details.dataset.rnsFaqBound = 'true';
      sync(details);
      details.addEventListener('toggle', function () {
        sync(this);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind(document);
    });
  } else {
    bind(document);
  }

  /*
    Theme editor only: Shopify replaces a section's markup wholesale when a
    setting changes, which drops every listener bound above. Re-binding on the
    event Shopify fires for exactly that is what keeps the editor honest about
    what a customer would get.
  */
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
